import { useEffect, useRef, useState } from 'react'
import { fetchMetadataWithCache, loadMetadataCache } from '../../helper/metadataCache'

const useLoadMetadataCache = () => {
  const initialCacheRef = useRef(loadMetadataCache())
  const [metadataResponse, setMetadataResponse] = useState(initialCacheRef.current || null)
  const [metadataLoading, setMetadataLoading] = useState(!initialCacheRef.current)

  useEffect(() => {
    let alive = true

    if (initialCacheRef.current) {
      return () => {
        alive = false
      }
    }

    fetchMetadataWithCache()
      .then((result) => {
        if (!alive) return
        setMetadataResponse(result || null)
      })
      .catch(() => {
        if (!alive) return
        setMetadataResponse(null)
      })
      .finally(() => {
        if (!alive) return
        setMetadataLoading(false)
      })

    return () => {
      alive = false
    }
  }, [])

  return {
    metadata: metadataResponse?.data || null,
    metadataResponse,
    metadataLoading
  }
}

export default useLoadMetadataCache
